<div id="app-modal" class="modal fade in" [ngClass]="{'show': isShow}" [hidden]="!isShow">
    <div class="modal-dialog" [style.width.px]="width">
        <div class="modal-content">
            <div class="modal-header">
                <button class="close" type="button" (click)="close()">
                    <span>×</span><span class="sr-only">Close</span>
                </button>
                <h4 class="modal-title">{{title}}</h4>
            </div>
            <div class="modal-body">
                <ng-template appModalHost></ng-template>
            </div>
            <div class="modal-footer">
                <button *ngFor="let button of modalService.modalButtons" type="button" (click)="button.onClick ? button.onClick() : close()" class="btn" [ngClass]="{'btn-primary': button.isPrimary}">{{button.name}}</button>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="close()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/modal-base/modal-base.component.html